import { MimeTypes } from "./proxies/MimeTypes";
import { WadoRsProxy } from "./proxies/WadoRsProxy";

export class RetrieveService {
  _retrieveService: WadoRsProxy;
  //_queryModel: QueryModel;

  constructor(retrieveServic: WadoRsProxy) {
    // this._retrieveService = retrieveServic;
    this._retrieveService = new WadoRsProxy();
  }

  getObjectInstance(
    instance: any,
    mediaType: string,
    successCallback: (data: any) => void
  ) {
    const data = this._retrieveService.getObjectInstance(
      instance.StudyInstanceUid,
      instance.SeriesInstanceUID,
      instance.SopInstanceUid,
      mediaType
    );
    return data;
    // .done((data: any) => {
    //   successCallback(data);
    // })
    // .fail((ev: Event) => {
    //   console.error("getObject failed");
    // });
  }

  async getSeries(
    series: any,
    successCallback: (data: any) => void,
    mediaType: string = "application/json"
  ) {
    if (null === mediaType) {
      mediaType = MimeTypes.Json;
    }

    const data: any = await this._retrieveService.getSeries(
      series.StudyInstanceUid,
      mediaType
    );
    return JSON.parse(data || "");
  }

  getSeriesMeta(
    series: any,
    successCallback: (data: any) => void,
    mediaType: string = "application/json"
  ) {
    if (null === mediaType) {
      mediaType = MimeTypes.Json;
    }

    const data = this._retrieveService.getSeriesMetadata(
      series.StudyInstanceUid,
      series.SeriesInstanceUID,
      mediaType
    );
    return data;
    // .done((data: any, textStatus: string, jqXHR: any) => {
    //   if (mediaType == MimeTypes.Json) {
    //     data = JSON.parse(data);
    //   }

    //   successCallback(data);
    // })
    // .fail((ev: Event) => {
    //   console.error("getStudyMetadata failed");
    // });
  }

  async getInstances(
    instance: any,
    successCallback: (data: any) => void,
    mediaType: string = "application/json"
  ) {
    if (null === mediaType) {
      mediaType = MimeTypes.Json;
    }

    const data: any = await this._retrieveService.getInstances(
      instance.StudyInstanceUid,
      instance.SeriesInstanceUid,
      mediaType
    );
    return JSON.parse(data || "");
  }
}
